import { render, staticRenderFns } from "./MyselfP.vue?vue&type=template&id=308bfbd0&scoped=true&"
import script from "./MyselfP.vue?vue&type=script&lang=js&"
export * from "./MyselfP.vue?vue&type=script&lang=js&"
import style0 from "./MyselfP.vue?vue&type=style&index=0&id=308bfbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308bfbd0",
  null
  
)

export default component.exports